import {combineReducers} from '@reduxjs/toolkit';

import collections from './collections.js';
import labs from './labs.js';
import map from './map.js';
import notifications from './notifications.js';
import search from './search.js';
import selectedFeatureRef from './selected-features.js';
import settings from './settings.js';
import tour from './tour.js';
import ui from './ui.js';

const combinedReducers = combineReducers({
  collections,
  labs,
  map,
  notifications,
  search,
  selectedFeatureRef,
  tour,
  ui,
  settings,
});

export default combinedReducers;
